<template>
  <el-dialog custom-class="convert-result-container dialog-size-large"
             title="変換結果"
             visible="true"
             append-to-body="true"
             :top="0"
             :modal="false"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="convert-result-container-inner">
      <fixed-header-table class="convert-result-overview" :fixed="true">
        <tr slot="header">
          <th>変換データ</th>
          <th>変換方法</th>
          <th style="flex-grow: 0; min-width: 120px;">変換日</th>
          <th style="flex-grow: 0; min-width: 120px;">件数</th>
        </tr>
        <tr>
          <td>{{uploadFileName}}</td>
          <td>{{converterName}}</td>
          <td style="flex-grow: 0; min-width: 120px;">{{convertResult.updatedAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD')}}
          </td>
          <td style="flex-grow: 0; min-width: 120px;">{{convertResult.resultCount | number_format}}</td>
        </tr>
      </fixed-header-table>
      <h3 style="margin-top: 16px; flex-shrink: 0;">結果のプレビュー</h3>
      <fixed-header-table
              :fixed="convertResult.resultPreview.results != null && convertResult.resultPreview.results.length > 0"
              style="max-height: 310px;">
        <tr slot="header">
          <th>{{convertResult.resultPreview.idName}}</th>
          <th v-for="header in convertResult.resultPreview.header">{{header}}</th>
        </tr>
        <tr v-for="result in convertResult.resultPreview.results">
          <td>{{result.id}}</td>
          <td v-for="header in convertResult.resultPreview.header">{{formatNumberCell(result, header)}}</td>
        </tr>
      </fixed-header-table>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <a :href="convertResult.resultFile">
        <el-button type="info" class="large" style="width: 320px; height: 50px;">結果をダウンロード</el-button>
      </a>
    </div>
  </el-dialog>
</template>

<script lang="js">
import { ConvertResult } from '../../../defines/convert'
import FormatUtil from '../../../utils/format'

export default {
  name: 'ConvertResultDialog',
  components: {},
  props: {
    converterName: '',
    uploadFileName: '',
    convertResult: ConvertResult
  },
  data () {
    return {}
  },
  methods: {
    formatNumberCell (row, column) {
      for (let val of row.value) {
        if (val['name'] === column) {
          return FormatUtil.formatNumber(val['value'], '-')
        }
      }
      return ''
    }
  }
}

</script>

<style scoped>
  .convert-result-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .convert-result-overview.table-wrapper.fixed {
    border-bottom: none;
    border-right: none;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .convert-result-overview.table-wrapper.fixed >>> .table-header > thead {
    padding-right: 0;
  }

  .convert-result-overview.table-wrapper.fixed >>> .table-body {
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/data-convert/dialogs/convert-result.vue